import DpcIcon from '@mui/icons-material/AccountBalance';
import KeyIcon from '@mui/icons-material/Key';
import StarIcon from '@mui/icons-material/Star';
import CourseIcon from '@mui/icons-material/VideoSettings';
import ExitIcon from '@mui/icons-material/ExitToApp';
import PriceIcon from '@mui/icons-material/Sell';
import CsvIcon from '@mui/icons-material/CloudDownload';
import ForumIcon from '@mui/icons-material/Forum';
import AccountIcon from '@mui/icons-material/ManageAccounts';
import PeopleIcon from '@mui/icons-material/People';
import HomeIcon from '@mui/icons-material/Home';
import SchoolIcon from '@mui/icons-material/School';
import HourglassIcon from '@mui/icons-material/HourglassTop';
//import ProspectIcon from '@mui/icons-material/PersonSearch';
import WorkIcon from '@mui/icons-material/Work';
import StatsIcon from '@mui/icons-material/QueryStats';
import SearchIcon from '@mui/icons-material/Search';
import CartIcon from '@mui/icons-material/LocalGroceryStore';
import TagIcon from '@mui/icons-material/Tag';
import TargetIcon from '@mui/icons-material/LocationSearching';
import UserIcon from '@mui/icons-material/Person';
import RocketIcon from '@mui/icons-material/RocketLaunch';
import SettingsIcon from '@mui/icons-material/Settings';
import SupportIcon from '@mui/icons-material/SupportAgent';
import DrawIcon from '@mui/icons-material/Draw';
import DesignIcon from '@mui/icons-material/DesignServices';
import FireIcon from '@mui/icons-material/Whatshot';
import EventIcon from '@mui/icons-material/Event';
import DescriptionIcon from '@mui/icons-material/Description';
import PlaceIcon from '@mui/icons-material/Place';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PrintIcon from '@mui/icons-material/Print';
import { txt } from '../services/translation';
import FlagIcon from '@mui/icons-material/Flag';

export const menus = {

    main: {
        title: txt('elearning'),
        tabs: [
            {
                id: 'enrollments', 
                title: txt('dashboard'), 
                path: '/enrollments', 
                icon: <DashboardIcon/>
            },
            {
                id: 'teacher', 
                title: txt('teacher'), 
                path: '/teacher', 
                icon: <HomeIcon/>, 
                roles: ['teacher']
            },
            {
                id: 'company', 
                title: txt('company'), 
                path: '/company', 
                icon: <WorkIcon/>, 
                roles: ['company']
            },
            {
                id: 'courses', 
                title: txt('catalogue'), 
                path: '/courses', 
                icon: <SearchIcon/>
            },
            {
                id: 'reviews', 
                title: txt('reviews'), 
                path: '/teacher/reviews', 
                icon: <StarIcon/>, 
                roles: ['teacher']
            },
            {
                id: 'social', 
                title: txt('community'), 
                path: '/community/feed', 
                icon: <ForumIcon/>
            },
            {
                id: 'back-office', 
                title: txt('backOffice'), 
                path: '/admin/courses', 
                icon: <SettingsIcon/>, 
                roles: ['admin']
            },
            {
                id: 'crm', 
                title: txt('crm'), 
                path: '/crm/activities', 
                icon: <SupportIcon/>, 
                roles: ['admin']
            },
            {
                id: 'marketing', 
                title: txt('marketing'), 
                path: '/marketing/stats', 
                icon: <RocketIcon/>, 
                roles: ['admin']
            },
            {
                id: 'profile', 
                title: txt('myAccount'), 
                path: '/profile', 
                icon: <UserIcon/>
            },
            {
                id: 'logout', 
                title: txt('logout'), 
                path: '/logout', 
                icon: <ExitIcon/>
            }
        ]
    },
    

    admin: {
        title: "Back-office",
        tabs: [
            {id: 'courses', title: 'Formations', path: '/admin/courses', icon: <CourseIcon/>},
            {id: 'prices', title: 'Prix formations', path: '/admin/prices', icon: <PriceIcon/>},
            {id: 'products', title: 'Produits', path: '/admin/products', icon: <CartIcon/>},
            {id: 'tags', title: 'Mots clés', path: '/admin/tags', icon: <KeyIcon/>},
            {id: 'dpc', title: 'DPC', path: '/admin/dpc/actions', icon: <DpcIcon/>},
            {id: 'csv', title: 'Extractions', path: '/admin/csv', icon: <CsvIcon/>},
            {id: 'logout', title: 'Tableau de bord', path: '/', icon: <ExitIcon/>}
        ]
    },
    

    marketing: {
        title: "Marketing",
        tabs: [
            {id: 'stats', title: 'Statistiques', path: '/marketing/stats', icon: <StatsIcon/>},
            {id: 'reviews', title: 'Avis', path: '/marketing/reviews', icon: <StarIcon/>},
            {id: 'sticker', title: 'Pixel', path: '/marketing/sticker/actions', icon: <TargetIcon/>},
            {id: 'logout', title: 'Tableau de bord', path: '/', icon: <ExitIcon/>}
        ]
    },


    crm: {
        title: "CRM",
        tabs: [
            {id: 'activities', title: 'Activités', path: '/crm/activities', icon: <HomeIcon/>},
            {id: 'persons', title: 'Contacts', path: '/crm/persons', icon: <PeopleIcon/>},
            {id: 'hots', title: 'Chauds', path: '/crm/hots', icon: <FireIcon/>},
            //{id: 'prospects', title: 'Prospects', path: '/crm/prospects', icon: <ProspectIcon/>},
            {id: 'enrollments', title: 'Inscriptions', path: '/crm/enrollments', icon: <SchoolIcon/>},
            {id: 'orphans', title: 'Non affecté DPC', path: '/crm/orphans', icon: <HourglassIcon/>},
            {id: 'companies', title: 'Entreprises', path: '/crm/groups', icon: <WorkIcon/>},
            {id: 'orders', title: 'Commandes', path: '/crm/orders', icon: <CartIcon/>},
            {id: 'events', title: 'Suivi client', path: '/crm/event-activities', icon: <TagIcon/>},
            {id: 'signatures', title: 'Signatures', path: '/crm/signatures', icon: <DrawIcon />},
            {id: 'logout', title: 'Tableau de bord', path: '/', icon: <ExitIcon/>}
        ]
    },


    social: {
        title: txt('community'),
        tabs: [
            {
                id: 'feed', 
                title: txt('newsFeed'), 
                path: '/community/feed', 
                icon: <ForumIcon/>
            },
            {
                id: 'mine', 
                title: txt('myPosts'), 
                path: '/community/mine', 
                icon: <AccountIcon/>
            },
            {
                id: 'favorites', 
                title: txt('myFavorites'), 
                path: '/community/favorites', 
                icon: <StarIcon/>
            },
            {
                id: 'logout', 
                title: txt('dashboard'), 
                path: '/', 
                icon: <ExitIcon/>
            }
        ]
    },


    design: {
        title: txt('design'),
        tabs: [
            {id: 'form', title: txt('training'), path: '/design/:id', icon: <SchoolIcon/>, roles: ['creator', 'admin']},
            {id: 'overview', title: txt('overview'), path: '/design/:id/overview', icon: <FlagIcon />, roles: ['admin']},
            {id: 'plan', title: txt('plan'), path: '/design/:id/plan', icon: <DesignIcon/>, roles: ['creator', 'admin']},
            {id: 'certificate', title: txt('certificate'), path: '/design/:id/certificate', icon: <PrintIcon/>, roles: ['creator','admin']},
            {id: 'home', title: txt('dashboard'), path: '/', icon: <ExitIcon/>, roles: ['creator', 'admin']}
        ]
    },


    organize: {
        title: "Événement",
        tabs: [
            {id: 'form', title: 'Général', path: '/organize/:id', icon: <EventIcon/>, roles: ['organizer','admin']},
            {id: 'overview', title: 'Détail', path: '/organize/:id/overview', icon: <DescriptionIcon/>, roles: ['organizer','admin']},
            {id: 'place', title: 'Lieu', path: '/organize/:id/place', icon: <PlaceIcon/>, roles: ['organizer','admin']},
            {id: 'products', title: 'Tarifs', path: '/organize/:id/products', icon: <PriceIcon/>, roles: ['organizer','admin']},
            {id: 'home', title: 'Tableau de bord', path: '/', icon: <ExitIcon/>, roles: ['organizer', 'admin']}
        ]
    },
    
};

export default menus;